/**
 * Reduce a request URL to a sanitized path: drop the query string and replace numeric / long-hex
 * id segments with `:param`. Used to feed the client request-log (and metrics) without storing ids,
 * tokens, or query values. Shared by both HTTP entry points (http-client + dedupFetch).
 */
export function sanitizePath(rawUrl: string): string {
  let pathname = rawUrl;
  try {
    const parsed = new URL(rawUrl, 'http://dummy');
    pathname = parsed.pathname;
  } catch {
    pathname = rawUrl.split('?')[0];
  }
  return pathname
    .split('/')
    .map((segment) =>
      /^(\d+|[0-9a-fA-F-]{8,}|v1\.[A-Za-z0-9_-]{22}\.[A-Za-z0-9_-]{43})$/.test(segment) ? ':param' : segment,
    )
    .join('/');
}
